var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg45(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0.5645170560688253"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 0L219.119 63V189L110 252L0.880798 189V63L110 0Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 0L219.119 63V189L110 252L0.880798 189V63L110 0Z",
    fill: "rgba(191, 191, 191, 100)",
    transform: "scale(1.3636363636363635, 1.1904761904761905)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110 0L219.119 63V189L110 252L0.880798 189V63L110 0Z",
    fill: "none",
    stroke: "#0c0c0c",
    strokeWidth: 0,
    clipPath: "url(#clip-0.5645170560688253)",
    transform: "scale(1.3636363636363635, 1.1904761904761905)",
    strokeDasharray: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg45);
export default __webpack_public_path__ + "static/media/45.d1f67ccb27a8fc19acd93cee3cda89f8.svg";
export { ForwardRef as ReactComponent };